<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="panel">
                <div class="dialog-title" v-t="title"></div>
                <hr class="dialog-hr">
                <div class="dialog-body">
                    <div class="inner-panel">
                        <div class="scrollable">
                            <component
                                v-if="selectedChild != null"
                                :is="selectedChild"
                                :selectedNode="compatSelectedNode"
                                :appData="appData"
                                :listType="tableListType"
                                :tableView="true"
                                @refresh="handleBodyRefresh"
                                @resetSelectedNode="handleResetSelectedNode"
                                @deleted="handleDeleted"
                            />
                        </div>
                    </div>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button @click="$emit('cancel')">閉じる</el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
/*
 * Table 形式の詳細表示専用ダイアログ。
 * 最小限の互換用 selectedNode だけを組み立てて渡す。
 */
import constants from '../../../constants.js';
import UserObject from '../object/UserObject.vue';
import TalkgroupObject from '../object/TalkgroupObject.vue';
import IpRadioObject from '../object/IPRadioObject.vue';

export default {
    name: 'TableDetailDialog',

    props: {
        id: {
            type: [Number, String],
            required: true
        },
        type: {
            type: [Number, String],
            required: true
        },
        tenantId: {
            type: [Number, String],
            required: true
        },
        name: {
            type: String,
            default: ''
        },
        displayName: {
            type: String,
            default: ''
        },
        appData: {
            type: Object,
            required: true
        }
    },

    components: {
        UserObject,
        TalkgroupObject,
        IpRadioObject,
    },

    data() {
        return {
            tableListType: -1,
            compatSelectedNode: null,
        };
    },

    computed: {
        selectedChild() {
            switch (this.type) {
                case constants.TABLE_OPTIONS.buddycomAccount.value:
                    return 'UserObject';
                case constants.TABLE_OPTIONS.group.value:
                    return 'TalkgroupObject';
                case constants.TABLE_OPTIONS.ipRadioAccount.value:
                    return 'IpRadioObject';
                default:
                    return null;
            }
        },
        title() {
            switch (this.type) {
                case constants.TABLE_OPTIONS.buddycomAccount.value:
                    return 'message.title_user_information';
                case constants.TABLE_OPTIONS.group.value:
                    return 'message.title_group_information';
                case constants.TABLE_OPTIONS.ipRadioAccount.value:
                    return 'message.title_ip_radio_information';
                default:
                    return '';
            }
        }
    },

    created() {
        this.rebuildCompatSelectedNode();
    },

    watch: {
        id() {
            this.rebuildCompatSelectedNode();
        },
        type() {
            this.rebuildCompatSelectedNode();
        },
        tenantId() {
            this.rebuildCompatSelectedNode();
        },
        name() {
            this.rebuildCompatSelectedNode();
        },
        displayName() {
            this.rebuildCompatSelectedNode();
        }
    },

    methods: {
        mapToObjectType() {
            switch (this.type) {
                case constants.TABLE_OPTIONS.buddycomAccount.value:
                    return constants.OBJECT_USER;
                case constants.TABLE_OPTIONS.group.value:
                    return constants.OBJECT_TALKGROUP;
                case constants.TABLE_OPTIONS.ipRadioAccount.value:
                    return constants.OBJECT_IP_RADIO;
                default:
                    return null;
            }
        },
        buildLabel() {
            if (this.type === constants.TABLE_OPTIONS.group.value) {
                return this.name || this.displayName || '';
            }
            if (this.displayName) {
                return `${this.name || ''} / ${this.displayName}`;
            }
            return this.name || '';
        },
        rebuildCompatSelectedNode() {
            const objectType = this.mapToObjectType();
            if (objectType == null) {
                this.compatSelectedNode = null;
                return;
            }

            const compatParentNode = {
                data: {
                    id: null,
                },
                childNodes: [],
                removeChild() {},
                insertChild() {},
                insertBefore() {},
                insertAfter() {},
                expand() {},
            };

            this.compatSelectedNode = {
                tenantId: this.tenantId,
                tree: {
                    $children: [],
                },
                node: {
                    data: {
                        tenantId: this.tenantId,
                        id: this.id,
                        label: this.buildLabel(),
                        type: objectType,
                        restrictions: [],
                        isLeaf: true,
                    },
                    parent: compatParentNode,
                }
            };
        },
        handleBodyRefresh() {
            this.$emit('refresh');
        },
        handleDeleted() {
            this.$emit('deleted');
        },
        handleResetSelectedNode() {
            this.$emit('cancel');
        }
    }
}
</script>

<style scoped>
.dialog-modal-mask {
    position: fixed;
    z-index: 1999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.panel {
    width: 800px;
    background-color: white;
    border-radius: 8px;
    padding: 20px 0px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.inner-panel {
    width: 100%;
    margin: 0 auto;
}

.dialog-body {
    height: 600px;
    overflow: auto;
}

.scrollable {
    overflow: auto;
}
</style>
